import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Camera } from 'lucide-react';
import WorkProjects from '../components/WorkProjects';
import UnreleasedWork from '../components/UnreleasedWork';
import ShowreelSection from '../components/ShowreelSection';
import ContactKomal from '../components/ContactKomal';
import FooterKomal from '../components/FooterKomal';

export default function WorkPage() {
  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      {/* Sticky top nav — same pattern as /portfolio */}
      <nav className="sticky top-0 z-40 bg-[#0a0a0a]/85 backdrop-blur-md border-b border-white/5">
        <div className="flex items-center justify-between px-4 md:px-10 py-3">
          <Link
            to="/"
            className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors group"
            data-testid="work-back-link"
          >
            <ArrowLeft size={14} className="group-hover:-translate-x-1 transition-transform" />
            <span className="text-[10px] uppercase tracking-[0.2em] font-light">Main Site</span>
          </Link>
          <span
            className="text-sm text-zinc-500 font-light tracking-wide hidden sm:block"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Komal Verma · Work
          </span>
          <Link
            to="/portfolio"
            className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-zinc-400 hover:text-[#FFD700] transition-colors font-light"
            data-testid="work-portfolio-link"
          >
            <Camera size={12} />
            <span>View Portfolio</span>
          </Link>
        </div>
      </nav>

      {/* Page sections — order matches user spec: Work → Showreel → Let's Connect */}
      <WorkProjects />
      <UnreleasedWork />
      <ShowreelSection />
      <ContactKomal />
      <FooterKomal />
    </div>
  );
}
